module.exports = __webpack_public_path__ + "static/img/static-zoom-in4.7083763.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static-zoom-in4.png
// module id = 78
// module chunks = 0